import { render } from "./BaseGalleryGridItem.vue?vue&type=template&id=52b18f0a&scoped=true"
import script from "./BaseGalleryGridItem.vue?vue&type=script&lang=js"
export * from "./BaseGalleryGridItem.vue?vue&type=script&lang=js"

import "./BaseGalleryGridItem.vue?vue&type=style&index=0&id=52b18f0a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b18f0a"]])

export default __exports__